import React from 'react';
import { BookOpenIcon, StarIcon, SunIcon, HashIcon, LayoutGridIcon, PenToolIcon, HeartHandshakeIcon } from 'lucide-react';
export function CourseContents() {
  return <section className="w-full bg-gray-50 py-16 md:py-20 px-4" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 text-center mb-12" data-id="element-118">
          📘 ¿Qué incluye exactamente el curso?
        </h2>

        <div className="space-y-6" data-id="element-119">
          {/* Module 1 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-120">
            <div className="flex items-start gap-4" data-id="element-121">
              <div className="flex-shrink-0 w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center" data-id="element-122">
                <BookOpenIcon className="w-6 h-6 text-gold-600" data-id="element-123" />
              </div>
              <div data-id="element-124">
                <h3 className="font-heading font-bold text-xl text-gray-900 mb-2" data-id="element-125">
                  🔹 Historia y simbolismo del Tarot
                </h3>
                <p className="font-body text-gray-600" data-id="element-126">
                  Entendé el origen y el significado profundo de cada carta.
                </p>
              </div>
            </div>
          </div>

          {/* Module 2 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-127">
            <div className="flex items-start gap-4" data-id="element-128">
              <div className="flex-shrink-0 w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center" data-id="element-129">
                <StarIcon className="w-6 h-6 text-gold-600" data-id="element-130" />
              </div>
              <div data-id="element-131">
                <h3 className="font-heading font-bold text-xl text-gray-900 mb-2" data-id="element-132">
                  🔹 Los 22 Arcanos Mayores
                </h3>
                <p className="font-body text-gray-600" data-id="element-133">
                  Descubrí el viaje del alma y cómo aplicarlo a tu vida.
                </p>
              </div>
            </div>
          </div>

          {/* Module 3 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-134">
            <div className="flex items-start gap-4" data-id="element-135">
              <div className="flex-shrink-0 w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center" data-id="element-136">
                <SunIcon className="w-6 h-6 text-gold-600" data-id="element-137" />
              </div>
              <div data-id="element-138">
                <h3 className="font-heading font-bold text-xl text-gray-900 mb-2" data-id="element-139">
                  🔹 Arcanos Menores en la vida cotidiana
                </h3>
                <p className="font-body text-gray-600" data-id="element-140">
                  Aprendé a interpretar situaciones reales con claridad.
                </p>
              </div>
            </div>
          </div>

          {/* Module 4 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-141">
            <div className="flex items-start gap-4" data-id="element-142">
              <div className="flex-shrink-0 w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center" data-id="element-143">
                <HashIcon className="w-6 h-6 text-gold-600" data-id="element-144" />
              </div>
              <div data-id="element-145">
                <h3 className="font-heading font-bold text-xl text-gray-900 mb-2" data-id="element-146">
                  🔹 Numerología y elementos en el Tarot
                </h3>
                <p className="font-body text-gray-600" data-id="element-147">
                  Conectá patrones y profundizá tus lecturas.
                </p>
              </div>
            </div>
          </div>

          {/* Module 5 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-148">
            <div className="flex items-start gap-4" data-id="element-149">
              <div className="flex-shrink-0 w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center" data-id="element-150">
                <LayoutGridIcon className="w-6 h-6 text-gold-600" data-id="element-151" />
              </div>
              <div data-id="element-152">
                <h3 className="font-heading font-bold text-xl text-gray-900 mb-2" data-id="element-153">
                  🔹 Tiradas prácticas (simples a avanzadas)
                </h3>
                <p className="font-body text-gray-600" data-id="element-154">
                  Desde la primera tirada hasta lecturas más completas.
                </p>
              </div>
            </div>
          </div>

          {/* Module 6 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-155">
            <div className="flex items-start gap-4" data-id="element-156">
              <div className="flex-shrink-0 w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center" data-id="element-157">
                <PenToolIcon className="w-6 h-6 text-gold-600" data-id="element-158" />
              </div>
              <div data-id="element-159">
                <h3 className="font-heading font-bold text-xl text-gray-900 mb-2" data-id="element-160">
                  🔹 Ejercicios de autoconocimiento
                </h3>
                <p className="font-body text-gray-600" data-id="element-161">
                  Integrá el Tarot en tu vida diaria.
                </p>
              </div>
            </div>
          </div>

          {/* Module 7 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-162">
            <div className="flex items-start gap-4" data-id="element-163">
              <div className="flex-shrink-0 w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center" data-id="element-164">
                <HeartHandshakeIcon className="w-6 h-6 text-gold-600" data-id="element-165" />
              </div>
              <div data-id="element-166">
                <h3 className="font-heading font-bold text-xl text-gray-900 mb-2" data-id="element-167">
                  🔹 Ética en la lectura
                </h3>
                <p className="font-body text-gray-600" data-id="element-168">
                  Aprendé a usar el Tarot con responsabilidad.
                </p>
              </div>
            </div>
          </div>
        </div>

        <p className="font-body text-base text-gray-600 text-center mt-10 italic" data-id="element-169">
          Todo basado en el mazo Rider-Waite-Smith, ideal para principiantes por
          su claridad visual y simbólica.
        </p>
      </div>
    </section>;
}